import React, { ReactNode } from 'react';
import { Grid } from '@mui/material';
import { ErrorOutline, InfoOutlined, Timer } from '@mui/icons-material';
import { rescheduleTheme } from '../rescheduleTheme';
import { RescheduleTypography } from './RescheduleTypography';

type NoticeProps = {
  variant: 'info' | 'warn' | 'error';
  title: string;
  body: string;
  icon?: ReactNode;
};

const variantStyles = {
  info: {
    background: rescheduleTheme.surfaceMuted,
    border: 'none',
    iconColor: rescheduleTheme.brand,
    titleColor: rescheduleTheme.text,
    bodyColor: rescheduleTheme.text,
    defaultIcon: <InfoOutlined />,
  },
  warn: {
    background: rescheduleTheme.warnBg,
    border: 'none',
    iconColor: rescheduleTheme.warnInk,
    titleColor: rescheduleTheme.warnInk,
    bodyColor: rescheduleTheme.warnInk,
    defaultIcon: <Timer />,
  },
  error: {
    background: '#FFFFFF',
    border: `1px solid ${rescheduleTheme.errorBorder}`,
    iconColor: rescheduleTheme.errorInk,
    titleColor: rescheduleTheme.errorInk,
    bodyColor: rescheduleTheme.text,
    defaultIcon: <ErrorOutline />,
  },
};

export const Notice = ({ variant, title, body, icon }: NoticeProps) => {
  const styles = variantStyles[variant];

  return (
    <Grid
      container
      role={variant === 'error' ? 'alert' : undefined}
      flexWrap="nowrap"
      sx={{
        gap: '12px',
        padding: '16px',
        borderRadius: `${rescheduleTheme.radii.control}px`,
        background: styles.background,
        border: styles.border,
      }}>
      <Grid item aria-hidden="true" sx={{ display: 'flex', flex: 'none', color: styles.iconColor }}>
        {icon ?? styles.defaultIcon}
      </Grid>
      <Grid container flexDirection="column" flexWrap="nowrap" width="auto" gap="4px">
        <RescheduleTypography style={{ fontSize: 16, fontWeight: 600, color: styles.titleColor }}>
          {title}
        </RescheduleTypography>
        <RescheduleTypography style={{ fontSize: 14, lineHeight: 1.5, color: styles.bodyColor }}>
          {body}
        </RescheduleTypography>
      </Grid>
    </Grid>
  );
};
